module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0142.jpg?v=d11e54a6";